 import { createSlice } from '@reduxjs/toolkit'
 
 export const slotCasinoPopUpSlice = createSlice({
   name: 'slotCasinoPopUp',
   initialState: {
    isOpen: false,
    allowed: false,
    openTimescount: 0,
   },
   reducers: {
    //  setSlotCasinoPopUp: (state, action) => action.payload,
     setSlotCasinoPopUp: (state, action) => ({...state, isOpen: action.payload}),
     setSlotCasinoPopupOpenCounts: (state, action) => ({...state, openTimescount: action.payload}),
     openSlotCasinoPopUp: (state, action) => {
      state.isOpen = true;
      
      // if (state.openTimescount === 0) {
      //   state.isOpen = true;
      //   state.openTimescount += 1;
      // }
    },
    setCasinoPopupAllowed: (state, action) => ({ ...state, allowed: action.payload }),
   },
 })
 
 export const { setSlotCasinoPopUp, setSlotCasinoPopupOpenCounts, openSlotCasinoPopUp, setCasinoPopupAllowed  } = slotCasinoPopUpSlice.actions
 
 export default slotCasinoPopUpSlice.reducer